import React from "react";
import { useFormContext } from "react-hook-form";
import ConfirmStep from "./ui/confirm-step";
import {
  AutoStackFormData,
  AutoStackStepType as StepType,
} from "../pages/Autostack";
import { formatDisplayValue } from "./ui/custom-frequency-dropdown";
import { useAssets } from "../hooks/useAssets";
import CurrencyFormatter from "../services/currencyFormatterService";
interface ConfirmAutoStackStepProps {
  onStepComplete: () => void;
  onStepBack: () => void;
  onCancel: () => void;
  currentStep: StepType;
}

const ConfirmAutoStackStep: React.FC<ConfirmAutoStackStepProps> = ({
  onStepComplete,
  onStepBack,
  onCancel,
}) => {
  const form = useFormContext<AutoStackFormData>();
  const formData = form.getValues();
  const { getAssetByValue } = useAssets();
  const currencyFormatter = new CurrencyFormatter({ locale: "en-ZA" });

  const getAssetInfo = (assetValue: string) => {
    return (
      getAssetByValue(assetValue) || {
        asset: "Unknown",
        assetName: "Unknown Asset",
        _id: assetValue,
        type: "Crypto" as const,
        status: "Enabled" as const,
      }
    );
  };

  const calculateTotalCost = (amount: string) => {
    const numericAmount = parseFloat(amount) || 0;
    return currencyFormatter.format(numericAmount, "fiat", "ZAR");
  };

  const selectedAsset = getAssetInfo(formData.assetToBuy);
  const formattedAmount = formData.stackAmount
    ? currencyFormatter.format(parseFloat(formData.stackAmount), "fiat", "ZAR")
    : currencyFormatter.format(0, "fiat", "ZAR");

  const transactionDetails = [
    { label: "Asset", value: selectedAsset.asset.toUpperCase() },
    {
      label: "Frequency",
      value: formatDisplayValue(formData.frequency, "Not selected"),
    },
    { label: "Start date", value: formData.startDateTime },
    { label: "Total cost", value: calculateTotalCost(formData.stackAmount) },
  ];

  const description =
    "Your wallet balance will be checked at the scheduled time. You'll be notified if funds are insufficient.";

  return (
    <ConfirmStep
      title="Confirm AutoStack"
      formattedAmount={formattedAmount}
      transactionDetails={transactionDetails}
      description={description}
      buttonText="Confirm"
      onStepComplete={onStepComplete}
      onStepBack={onStepBack}
      onCancel={onCancel}
    />
  );
};

export default ConfirmAutoStackStep;
